import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ButtonClose from 'shared/ButtonClose/ButtonClose';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "Quick Links",
    menus: [
      { href: "/#/about",onClick:"", label: "About us" },
      { href: "https://blog.esanchari.com",onClick:"", label: "Blogs" },
      { href: "/#/collaborate",onClick:"", label: "Partner with us" },
      { href: "#/contact",onClick:"", label: "Contact Us" },
      
    ],
  },
  {
    id: "1",
    title: "Policies",
    menus: [
      { href: "#/privacypolicy",onClick:"", label: "Privacy Policy" },
      { href: "#/paymentpolicy",onClick:"", label: "Payment Policy" },
      { href: "#/refundpolicy", onClick:"", label: "Refund Policy" },
      { href: "#/termsconditionpolicy",onClick:"",  label: "Terms & Conditions" },
   
    ],
  }
];

const Footer: React.FC = () => {
  const [footerPopup, setFooterPopup] = useState(false);
  const [trmstext, settrmstext] = useState("");

  const getTnCData = (type:string) => {
    let url: string = "";
    if(type == 'privacy'){
      url = 'https://sanchari-dev-resources.s3.ap-south-1.amazonaws.com/TermsAndConditions/PrivacyPolicy.html';
    }
    else if(type == 'payment'){
      url = 'https://sanchari-dev-resources.s3.ap-south-1.amazonaws.com/TermsAndConditions/PaymentPolicy.html';
    }
    else if(type == 'return'){
      url = 'https://sanchari-dev-resources.s3.ap-south-1.amazonaws.com/TermsAndConditions/CancellationandReturnPolicy.html';
    }
    else{
      url = 'https://sanchari-dev-resources.s3.ap-south-1.amazonaws.com/TermsAndConditions/TermsandConditions.html';
    }
    return url;
    // axios
    //   .get(url)
    //   .then((response) => {
    //     settrmstext(response.data)
    //   })
  };

  function closeModalterms() {
    setFooterPopup(false);
  }

  function openModalterms(val:any) {
    // let url = getTnCData(val);
    window.open(val, '_blank', 'noopener,noreferrer');
    //setFooterPopup(true);
  }

  const policyModal = () => {
    return (
      <Transition appear show={footerPopup} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalterms}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      Terms and Conditions
                    </h3>
                    <span className="absolute right-3 top-3">
                      <ButtonClose onClick={closeModalterms} />
                    </span>
                  </div>
                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                  <div className="p-3" dangerouslySetInnerHTML={{__html: trmstext}}/>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };
  
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    
    return (
      <div key={index} className="hidden lg:block pt-5 text-sm">
        <h2 className="font-semibold text-red-600 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              {item.onClick == "" ?
                <a
                  key={index}
                  className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                  href={item.href}
                >
                  {item.label}
                </a>
                :
                <a
                  key={index}
                  className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                  href={"javascript:void();"}
                  onClick={() => openModalterms(item.href)}
                >
                  {item.label}
                </a>
              }
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div>
      <div className="nc-Footer relative lg:py-8 border-t border-neutral-200 dark:border-neutral-700">
        <div className="container grid grid-cols-2 grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-4 lg:gap-x-10 ">
          <div className="grid grid-cols-4 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
            <div className="col-span-2 md:col-span-1">
              <Logo />
            </div>
            <div className="block lg:hidden col-span-2 flex items-center md:col-span-3">
              <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
            </div>
            <div className="hidden lg:block">
              <div className="pb-2 text-neutral-600 dark:text-neutral-300 hover:text-black dark:hover:text-white">
                {/* <span className="text-sm">Powered by</span><br/> */}
                <span>
                  <a className="text-sm" href="https://digiverti.com">
                    Product of Digiverti Infotech Pvt. Ltd.
                  </a>
                </span>
              </div>
              <div>
                <QRCodeSVG style={{ border: '2px solid #ffffff', height: '6rem', width: '6rem' }}
                  value="https://linktr.ee/esanchariindia?utm_source=qr_code" />
                <p className="text-sm text-neutral-600 dark:text-neutral-300 hover:text-black">Scan for more info</p>
              </div>
            </div>
          </div>
          {/* {policyModal()} */}
          {widgetMenus.map(renderWidgetMenuItem)}
          <div className="hidden pt-5 lg:block col-span-1 flex items-center lg:md:col-span-1">
            <div className="text-sm">
              <h2 className="font-semibold text-red-600 dark:text-neutral-200">
                Quick Connect
              </h2>
              <ul className="mt-5 space-y-4">
                <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
              </ul>
            </div>
          </div>
        </div>

      </div>
      <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-3 text-center">
        Copyright (c) 2023 eSanchari.com. All rights reserved.
      </p>
      <br />
    </div>

  );
};

export default Footer;
